// Subtle inline status shown while Courtney is being brought back into the chat
// after an unexpected drop. Replaces the error banner; no action needed.
export function ReconnectStatus() {
  return (
    <div className="lk-widget-reconnect" role="status" aria-live="polite">
      <span className="lk-widget-reconnect-dot" aria-hidden="true" />
      <span>Reconnecting to Courtney…</span>
    </div>
  );
}
